import React, {useState, useEffect} from 'react'
import { useTranslation } from "react-i18next";
import { LIMIT_PAGE } from "constants/variables";
import Box from '@mui/material/Box';  
import DeleteIcon from '@mui/icons-material/Delete';
import Checkbox from '@mui/material/Checkbox';
import EditIcon from '@mui/icons-material/Edit';
import Icon from '@mui/material/Icon'; 
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage'; 
import Paper from '@mui/material/Paper';  
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel'; 
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography'; 
import TableFooter from '@mui/material/TableFooter';
import TextField from '@mui/material/TextField';
import useTheme from '@mui/material/styles/useTheme';   
import visuallyHidden from '@mui/utils/visuallyHidden';
import "css/customDialog.css";
import PropTypes from 'prop-types';

const headCellsTypesOfSizes = [
  {
    id: 'indexrowypesofsizes',
    numeric: true,
    disablePadding: false,
    label: 'Text_Row',
    canOrder:true,
  },
  {
    id: 'enabletypesofsizearticle',
    numeric: false,
    disablePadding: false,
    label: 'Text_EnableTypesOfSizeArticle',
    canOrder:false,
  },
  {
    id: 'typeofsize_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_TypesOfSizeArticle',
    canOrder:true,
  },
  {
    id: 'typeofsize_symbolsizes',
    numeric: false,
    disablePadding: false,
    label: 'Text_SymbolSizesArticle',
    canOrder:true,
  }
];

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  ordertypesofsize: PropTypes.oneOf(['asc', 'desc']).isRequired,
  ordertypesofsizeBy: PropTypes.string.isRequired,
};

function descendingComparator(a, b, ordertypesofsizeBy) {
    if (b[ordertypesofsizeBy] < a[ordertypesofsizeBy]) {
        return -1;
    }
    if (b[ordertypesofsizeBy] > a[ordertypesofsizeBy]) {
        return 1;
    }
    return 0;
}
  
function getComparator(ordertypesofsize, ordertypesofsizeBy) {
    return ordertypesofsize === 'desc' ? (a, b) => descendingComparator(a, b, ordertypesofsizeBy) : (a, b) => -descendingComparator(a, b, ordertypesofsizeBy);
}
  
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const ordertypesofsize = comparator(a[0], b[0]);
        if (ordertypesofsize !== 0) {
        return ordertypesofsize;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { ordertypesofsize, ordertypesofsizeBy, onRequestSort, t,roles } = props;
  const createSortHandler = (property) => (event) => { onRequestSort(event, property); };
  return (
    <TableHead>
      <TableRow>
        {roles[0].listmenus.find((key)=>(key.name==='Handle_Article_Modify_TypesOfSizes'))&&
          <TableCell
            key='edit'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#4e73df", fontSize: 16}}>
              {t('Button_Edit')}
            </Typography>
          </TableCell>
        }
        {headCellsTypesOfSizes.map((headCell, indexhead) => (
          <TableCell
            key={indexhead}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={ordertypesofsizeBy === headCell.id ? ordertypesofsize : false}
          >
            {headCell.canOrder ?(
            <TableSortLabel
              active={ordertypesofsizeBy === headCell.id}
              direction={ordertypesofsizeBy === headCell.id ? ordertypesofsize : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
                {ordertypesofsizeBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {ordertypesofsize === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>):
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
              </Typography>}
          </TableCell>
        ))}
       
         {roles[0].listmenus.find((key)=>(key.name==='Handle_Article_Delete_TypesOfSizes'))&&
        <TableCell
          key='delete'
          align='center'
          padding='normal'
          sortDirection={false}
        >
          <Typography style={{color:"#e74a3b", fontSize: 16}} > 
            {t('Button_Delete')}
          </Typography>
        </TableCell>}
      </TableRow>
    </TableHead>
  );
}

const EnhancedTableToolbar = (props) => {
  const { numTotRegTypesOfSize, t, roles,setOpenEditNewTypesOfSize,setOpenEditRowTypesOfSize,setFormArticle,dataTypesOfSizes,typesOfSizeToSelect} = props;
  const handleAddNewTypesOfSize = () => {
      setOpenEditNewTypesOfSize(false);
      setOpenEditRowTypesOfSize(true);  
  };

   const handleCopyALLTypesOfSize= () => {   
      let count= dataTypesOfSizes[0].indexrowypesofsizes+1;
      for (let i = 0; i<typesOfSizeToSelect.length; i++){
        if(typesOfSizeToSelect[i].id!== dataTypesOfSizes[0].typeofsize_id){
          let storeTypesOfSizeToAdd={
            "id":"",
            "indexrowypesofsizes" : count,
            "enabletypesofsizearticle" : dataTypesOfSizes[0].enabletypesofsizearticle,
            "typeofsize_id" :typesOfSizeToSelect[i].id,
            "typeofsize_namees" : typesOfSizeToSelect[i].namees,
            "typeofsize_nameen" : typesOfSizeToSelect[i].nameen,
            "typeofsize_symbolsizes" : typesOfSizeToSelect[i].symbolsizes
          }
          dataTypesOfSizes.push(storeTypesOfSizeToAdd); 
          count++;
        } 
      }
      setFormArticle(formArticle => ({
        ...formArticle,
     }))
  };

  return (
      <Toolbar>
      <Typography style={{flex: '1 1 100%',color:"#4e73df", fontSize: 16}} id="tableTitle" component="div">
        {t('Text_Article_TypesOfSize')} &nbsp;&nbsp;
        { ((typesOfSizeToSelect.length-numTotRegTypesOfSize)>0 && roles[0].listmenus.find((key)=>(key.name==='Handle_Article_Add_TypesOfSizes')))&&
          <>
            <IconButton
              size="small"  
              style={{color:"#e74a3b", fontSize: 16}}
              onClick={handleAddNewTypesOfSize}>
                <Icon
              baseClassName="fas"
              className="fa-plus add-icon-button"
            /> 
            </IconButton>&nbsp;&nbsp;
            { numTotRegTypesOfSize===1 && 
              <> 
                <IconButton
                  size="small"  
                  style={{color:"#e74a3b", fontSize: 16}}
                  onClick={handleCopyALLTypesOfSize}>
                  <Icon
                    baseClassName="fas"
                    className="fa-clone"
                    sx={{ color:"#4e73df"}}
                  />
                  &nbsp;&nbsp;
                </IconButton>   
              </>
            }
          </>
        }
      </Typography>
      <Typography style={{flexShrink: 0, ml: 2.5, color:"#4e73df", fontSize: 14}} id="tableTitle" component="div">
        {t('Text_Num_Reg')} {(numTotRegTypesOfSize).toLocaleString('de-DE')} {t('Text_Of')}  {(numTotRegTypesOfSize).toLocaleString('de-DE')}
      </Typography>
    </Toolbar>
  );
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  const {t} = useTranslation(['listDataArticles']);

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label={t('Text_First_Page')}
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label={t('Text_Previous_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Next_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Last_Page')}
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export const TableSortingTypesOfSizes =(props)=>{
  const { dataTypesOfSizes, setFormArticle, numTotRegTypesOfSize, setOpenDeleteRowTypesOfSize, setOpenEditNewTypesOfSize, setOpenEditRowTypesOfSize, setEditRowTypesOfSize, roles, typesOfSizeToSelect,formArticle} = props;
  const {t,i18n} = useTranslation(['listDataArticles']);
  const [ordertypesofsize, setOrderTypesOfSize] = useState('asc');
  const [ordertypesofsizeBy, setOrderTypesOfSizeBy] = React.useState('calories');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [emptyRowsTypesOfSize, setEmptyRowsTypesOfSize] = useState(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataTypesOfSizes.length) : 0);
  const [countData,setCountData] = useState(dataTypesOfSizes.length);
  const [activeOffsetTypesOfSize, setActiveOffsetTypesOfSize]= useState(false);
  const [currencyOffsetTypesOfSize, setCurrencyOffsetTypesOfSize] = useState(1);
  const [rangeOffsetTypesOfSize, setRangeOffsetTypesOfSize] = useState([{}]);

    useEffect(() => {
      if (dataTypesOfSizes.length !== countData || dataTypesOfSizes.length <= rowsPerPage) {
        setPage(0);
      }  
      setCountData(dataTypesOfSizes.length);
      setEmptyRowsTypesOfSize(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataTypesOfSizes.length) : 0);
    }, [dataTypesOfSizes, rowsPerPage, page, countData]);
    
    useEffect(() => {
      if (numTotRegTypesOfSize > LIMIT_PAGE) {
        setActiveOffsetTypesOfSize(true);
        const ranges = [
          {
            value: 1,
            label: " 1 - " + Number(LIMIT_PAGE).toLocaleString('de-DE'),
          },
        ];
        for (let i = Number(LIMIT_PAGE); i < numTotRegTypesOfSize; i += Number(LIMIT_PAGE)) {
          ranges.push({
            value: (i / Number(LIMIT_PAGE)) + 1,
            label: " " + (i + 1).toLocaleString('de-DE') + " - " + (i + Number(LIMIT_PAGE)).toLocaleString('de-DE'),
          });
        }
        setRangeOffsetTypesOfSize(ranges);
      } else {
        setCurrencyOffsetTypesOfSize(1);
        setActiveOffsetTypesOfSize(false);
        setRangeOffsetTypesOfSize([{}]);
      }
    }, [numTotRegTypesOfSize]);

  const handleChangeOffset = (event) => {
    setCurrencyOffsetTypesOfSize(event.target.value);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = ordertypesofsizeBy === property && ordertypesofsize === 'asc';
    setOrderTypesOfSize(isAsc ? 'desc' : 'asc');
    setOrderTypesOfSizeBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const openModalDeleteRowTypesOfSizes = (row) => {
    setEditRowTypesOfSize(row);
    setOpenDeleteRowTypesOfSize(true);
  };

  const openEditRowTypesOfSizes = (row) => {
    setEditRowTypesOfSize(row);
    setOpenEditNewTypesOfSize(true);
    setOpenEditRowTypesOfSize(true);
  };

  const handleChangeEnabledArticle = (item) => {
    var i =  dataTypesOfSizes.indexOf( item );
    dataTypesOfSizes.map((item,index)=>{
      if ( index===i ) {
        return item.enabletypesofsizearticle=!item.enabletypesofsizearticle
      } else{
        return item.enabletypesofsizearticle
      }
    })
    setFormArticle(formArticle => ({
       ...formArticle,
    }))
  };

  const listItems= (
  stableSort(dataTypesOfSizes, getComparator(ordertypesofsize, ordertypesofsizeBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, keydataTypesOfSizes) => {
    return (
      <TableRow hover tabIndex={-1} key={keydataTypesOfSizes}>
       {(roles[0].listmenus.find((key)=>(key.name==='Handle_Article_Modify_TypesOfSizes')))&&
        <TableCell align="center">
          <IconButton size="large" className="edit-icon-button" onClick={()=>openEditRowTypesOfSizes(row)}>
            <EditIcon/>
          </IconButton>
        </TableCell>}
        <TableCell align="right">
          <Typography style={{color:"#4e73df", fontSize: 16}} >
            {row.indexrowypesofsizes}
          </Typography>
        </TableCell>
          <TableCell align="center">
          <Checkbox checked={row.enabletypesofsizearticle} 
            sx={{
              '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 28 }, // Ajusta el tamaño del ícono
            }} 
            onClick={()=>handleChangeEnabledArticle(row)}/>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#4e73df", fontSize: 16}} >
            {i18n.language==="es"?row.typeofsize_namees:row.typeofsize_nameen}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#4e73df", fontSize: 16}} >
              {row.typeofsize_symbolsizes}
          </Typography>  
        </TableCell>
        {(roles[0].listmenus.find((key)=>(key.name==='Handle_Article_Delete_TypesOfSizes'))) &&
         <TableCell align="center">
          <IconButton size="large" className={formArticle.articlestoretypesofprices.findIndex(((item) => item.typeofsize_id === row.typeofsize_id))>=0?"delete-noicon-button":"delete-icon-button"} onClick={()=>openModalDeleteRowTypesOfSizes(row)} disabled={formArticle.articlestoretypesofprices.findIndex(((item) => item.typeofsize_id === row.typeofsize_id))>=0}>
            <DeleteIcon/>
          </IconButton>
        </TableCell>}
      </TableRow>
    );
  }));
  
  return(
    <>
      <Box sx={{ width: '100%' }}> 
        <EnhancedTableToolbar numTotRegTypesOfSize={numTotRegTypesOfSize} t={t} roles={roles} setOpenEditNewTypesOfSize={setOpenEditNewTypesOfSize} setOpenEditRowTypesOfSize={setOpenEditRowTypesOfSize} setFormArticle={setFormArticle} dataTypesOfSizes={dataTypesOfSizes} typesOfSizeToSelect={typesOfSizeToSelect}/>
          <TableContainer component={Paper} className="formdi-table-container" >
            <Table sx={{ minWidth: '1060px',width: '100%' }} stickyHeader size="small"  aria-labelledby="tableTitle"> 
              <EnhancedTableHead ordertypesofsize={ordertypesofsize} ordertypesofsizeBy={ordertypesofsizeBy} onRequestSort={handleRequestSort} t={t} roles={roles}/>
              <TableBody>    
                {listItems}
                {emptyRowsTypesOfSize > 0 && (
                <TableRow style={{ height: 33  * emptyRowsTypesOfSize}}>
                  <TableCell colSpan={6} />
                </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                {activeOffsetTypesOfSize && (
                    <TableCell colSpan={2}>
                      <Box sx={{ flexShrink: 0, p: 1}}>
                        <div className="form-group">
                          <TextField
                            id="currencyOffsetTypesOfSize"
                            name="currencyOffsetTypesOfSize"
                            value={currencyOffsetTypesOfSize}
                            inputProps={{ style: {maxLength: 100, color:"#4e73df",fontSize:14}}}
                            placeholder={t('Text_Range_Offset')}
                            variant="standard"
                            onChange={handleChangeOffset}
                            helperText={t('Text_Range_Offset')}
                            select
                            SelectProps={{
                              native: true,
                              value: currencyOffsetTypesOfSize
                            }}>
                            {rangeOffsetTypesOfSize.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                          ))}
                          </TextField>
                        </div>
                      </Box>  
                    </TableCell>
                  )}
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    colSpan={6}
                    count={countData}
                    rowsPerPage={rowsPerPage}
                    page={countData===0?0:page}
                    labelRowsPerPage={t('Text_Rows_Per_Page')}
                    slotProps={{
                      inputProps: {
                        'aria-label': t('Text_Rows_Per_Page'),
                      },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
      </Box>
    </>
  )
}

TableSortingTypesOfSizes.propTypes = {
  dataTypesOfSizes: PropTypes.array.isRequired,
  setFormArticle: PropTypes.func.isRequired, 
  numTotRegTypesOfSize: PropTypes.number.isRequired,
  setOpenDeleteRowTypesOfSize: PropTypes.func.isRequired,
  setOpenEditNewTypesOfSize: PropTypes.func.isRequired,
  setOpenEditRowTypesOfSize: PropTypes.func.isRequired,
  setEditRowTypesOfSize: PropTypes.func.isRequired,
  roles: PropTypes.array.isRequired
};

export default TableSortingTypesOfSizes;